<app-dialog
  #dialog
  [key]="'valor-deal'"
  [action]="'valor-deal'"
  [headerTheme]="'simple'"
  [title]="'Alterar valor pretendido'"
  [appendTo]="'body'"
  [maxWidth]="'480px'">
  <!-- `appAutoFormGroup` obrigatório junto do `[formGroup]`: sem ele o `app-input` cria
       controle próprio, a tela fica preenchida e o formulário do componente nasce vazio e
       inválido — botão travado, sem erro no console. -->
  <div class="p-4" [formGroup]="form" appAutoFormGroup>
    <!-- Qual deal está sendo alterado. No board os cards são pequenos e parecidos; sem isto
         a pessoa não tem como conferir que clicou no certo. -->
    <div class="row">
      <div class="col-12">
        <label class="modal-valor__rotulo">Deal</label>
        <p class="modal-valor__deal">#{{ deal?.sequentialId }} · {{ deal?.corporateName }}</p>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-md-7">
        <app-input
          label="Valor pretendido"
          type="number"
          prefix="R$ "
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [required]="true"
          [formGroup]="form"
          controlName="amount" />
      </div>
      <div class="col-12 col-md-5">
        <app-select
          [label]="'Moeda'"
          [options]="moedas"
          formControlName="currencyCode"
          [placeholder]="'Selecione'"></app-select>
      </div>
    </div>
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        [disabled]="!isFormValid()"
        [isLoading]="gravando"
        [loadingText]="'Salvando...'"
        [label]="'Salvar'"
        [type]="'button'"
        (sendButtonClick)="submitAction()"></app-button>
    </div>
  </ng-template>
</app-dialog>
